import config from "react-global-configuration";

// @ts-ignore
const env = OCC_ENV || "development"; // injected by webpack.DefinePlugin
const configs = require(`configs/${env}.json`);
// @ts-ignore
const version = VERSION; // injected by webpack.DefinePlugin

const overrides: Record<string, string> = {};
if (env === "development") {
  // URL overrides injected by webpack.DefinePlugin — set when API_URL/APP_URL/ANALYTICS_URL
  // env vars are present at webpack startup.
  // @ts-ignore
  const apiUrl: string | null = API_URL;
  // @ts-ignore
  const appUrl: string | null = APP_URL;
  // @ts-ignore
  const analyticsUrl: string | null = ANALYTICS_URL;

  if (apiUrl) {
    overrides.BASE_URL = apiUrl;
  }
  if (appUrl) {
    overrides.APP_URL = appUrl;
    overrides.CUSTOMER_URL = appUrl;
    overrides.CUSTOMER_URL_SSL = appUrl;
    overrides.OIDC_REDIRECT_URL = `${appUrl}/sso/callback`;
    overrides.DABELLA_OKTA_REDIRECT_URL = `${appUrl}/okta/callback`;
    overrides.DABELLA_OKTA_LOGOUT_URL = `${appUrl}/okta/logout`;
  }
  if (analyticsUrl) {
    overrides.STORAGE_URL = analyticsUrl;
    overrides.RSF_ANALYTICS_URL = analyticsUrl;
    overrides.RSF_ANALYTICS_WS = analyticsUrl.replace(/^https?/, (p) => (p === "https" ? "wss" : "ws"));
  }
}

config.set({ ...configs, ...overrides, VERSION: version });
